import { render, staticRenderFns } from "./EditAppConfig.vue?vue&type=template&id=5ac69517"
import script from "./EditAppConfig.vue?vue&type=script&lang=js"
export * from "./EditAppConfig.vue?vue&type=script&lang=js"
import style0 from "./EditAppConfig.vue?vue&type=style&index=0&id=5ac69517&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports